import { render } from "./PTServices.vue?vue&type=template&id=4049faf8&scoped=true"
import script from "./PTServices.vue?vue&type=script&lang=js"
export * from "./PTServices.vue?vue&type=script&lang=js"

import "./PTServices.vue?vue&type=style&index=0&id=4049faf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4049faf8"]])

export default __exports__